/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown>, unit: NonNullable<unknown> }} Order_Lot_Trace_Virtual_Body_CancelledInputs */

const vi_order_lot_trace_virtual_body_cancelled = /** @type {(inputs: Order_Lot_Trace_Virtual_Body_CancelledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đơn đã hủy — ${i?.qty} ${i?.unit} này chưa từng có lô thật, kho không nhập bù nữa.`)
};

/**

* @param {Order_Lot_Trace_Virtual_Body_CancelledInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_virtual_body_cancelled = /** @type {((inputs: Order_Lot_Trace_Virtual_Body_CancelledInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_Virtual_Body_CancelledInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_virtual_body_cancelled(inputs)
});